import { DoctorRepository } from "@/domain/repository/doctor-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class UpdateDoctorUsecase {
  constructor(private readonly doctorRepo: DoctorRepository) {}

  async execute(
    doctorUuid: string,
    payload: Record<string, unknown>,
  ): Promise<SATResult<void, SATError>> {
    return this.doctorRepo.updateDoctor(doctorUuid, payload);
  }
}
